import styled from 'styled-components';

export default styled.div`
	border-top: var(--px-1) solid var(--dropdown-menu--border-color);
	padding: var(--px-10) var(--px-14);
	display: flex;
	justify-content: space-between;
	gap: var(--px-8);
`;
